export const userdata = {
    GET_USERDATA: "GET_USERDATA",
}
